/**
 * Where the action came from, derived from audit_log.actor_type.
 * There is no finer source (cron vs webhook vs edge) in the row.
 */

export const AUDIT_ORIGIN_LABELS = {
  staff: "Admin",
  member: "App",
  system: "Automático",
  platform: "Platform",
} as const;

export type AuditOrigin = keyof typeof AUDIT_ORIGIN_LABELS;

export function labelForAuditOrigin(actorType: string): string {
  return AUDIT_ORIGIN_LABELS[actorType as AuditOrigin] ?? actorType;
}

export const AUDIT_ORIGIN_OPTIONS: { value: AuditOrigin; label: string }[] = [
  { value: "staff", label: AUDIT_ORIGIN_LABELS.staff },
  { value: "member", label: AUDIT_ORIGIN_LABELS.member },
  { value: "system", label: AUDIT_ORIGIN_LABELS.system },
  { value: "platform", label: AUDIT_ORIGIN_LABELS.platform },
];
